export default __webpack_public_path__ + "static/media/plus.092a3019.svg";